export class MicIcon {
  public micIconUnmuted: SVGElement;
  public micIconMuted: SVGElement;

  constructor() {
    this.micIconUnmuted = this.createMicIconUnmuted();
    this.micIconMuted = this.createMicIconMuted();
  }

  private createMicIconUnmuted(): SVGElement {
    const micIcon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    micIcon.setAttributeNS(null, "id", "micIconUnmuted");
    micIcon.setAttributeNS(null, "x", "24px");
    micIcon.setAttributeNS(null, "y", "24px");
    micIcon.setAttributeNS(null, "viewBox", "0 -1 24 24");

    const svgGroup = document.createElementNS("http://www.w3.org/2000/svg", "g");
    svgGroup?.classList?.add("svgIcon");
    micIcon.appendChild(svgGroup);

    const path1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path1.setAttributeNS(
      null,
      "d",
      "M12 14c1.66,0,2.99-1.34,2.99-3L15,5c0-1.66-1.34-3-3-3S9,3.34,9,5v6c0,1.66,1.34,3,3,3zm5.3-3c0,3-2.54,5.1-5.3,5.1S6.7,14,6.7,11H5c0,3.41,2.72,6.23,6,6.72V21h2v-3.28c3.28-.48,6-3.3,6-6.72h-1.7z"
    );
    svgGroup.appendChild(path1);

    return micIcon;
  }

  private createMicIconMuted(): SVGElement {
    const micIcon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    micIcon.setAttributeNS(null, "id", "micIconMuted");
    micIcon.setAttributeNS(null, "x", "24px");
    micIcon.setAttributeNS(null, "y", "24px");
    micIcon.setAttributeNS(null, "viewBox", "0 -1 24 24");

    const svgGroup = document.createElementNS("http://www.w3.org/2000/svg", "g");
    svgGroup?.classList?.add("svgIcon");
    micIcon.appendChild(svgGroup);

    const path1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path1.setAttributeNS(
      null,
      "d",
      "M19,11h-1.7c0,.74-.16,1.43-.43,2.05l1.23,1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9,3.34,9,5v.18l5.98,5.99zM4.27,3,3,4.27l6.01,6.01V11c0,1.66,1.33,3,2.99,3,.22,0,.44-.03.65-.08l1.66,1.66c-.71.33-1.5.52-2.31.52-2.76,0-5.3-2.1-5.3-5.1H5c0,3.41,2.72,6.23,6,6.72V21h2v-3.28c.91-.13,1.77-.45,2.54-.9L19.73,21,21,19.73,4.27,3z"
    );

    svgGroup.appendChild(path1);

    return micIcon;
  }
}
